import { fetchWrapper } from '../../fetch';
import { baseURL, deserialize } from '../../helpers';
import type { FileShareListing } from './interface';

function fileShareUrl(
  region: string,
  path: string,
  params: Record<string, string | undefined> = {}
): string {
  const url = new URL(`/api/v1/file-share/${region}/${path}`, baseURL);
  for (const [key, value] of Object.entries(params)) {
    if (value) {
      url.searchParams.set(key, value);
    }
  }
  return url.href;
}

const fileShareApiClient = {
  list: async (region: string, prefix?: string): Promise<FileShareListing> => {
    const response = await fetchWrapper(
      fileShareUrl(region, 'object', { prefix }),
      { method: 'GET', credentials: 'include' }
    );
    return deserialize(response);
  },
  upload: async (
    region: string,
    prefix: string | undefined,
    file: File
  ): Promise<void> => {
    const { url, contentType } = await deserialize(
      await fetchWrapper(
        fileShareUrl(region, 'upload-url', {
          prefix,
          name: file.name,
          'content-type': file.type,
          size: String(file.size),
        }),
        {
          method: 'POST',
          credentials: 'include',
          headers: { 'Content-Type': 'application/json' },
        }
      )
    );
    const response = await fetchWrapper(
      url,
      {
        method: 'PUT',
        headers: { 'Content-Type': contentType, 'If-None-Match': '*' },
        body: file,
      },
      0
    );
    await deserialize(response);
  },
  downloadUrl: async (
    region: string,
    prefix: string | undefined,
    name: string
  ): Promise<{ url: string }> =>
    deserialize(
      await fetchWrapper(
        fileShareUrl(region, 'download-url', { prefix, name }),
        { method: 'GET', credentials: 'include' }
      )
    ),
  createFolder: async (
    region: string,
    prefix: string | undefined,
    name: string
  ): Promise<void> => {
    const response = await fetchWrapper(
      fileShareUrl(region, 'folder', { prefix, name }),
      {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
      }
    );
    await deserialize(response);
  },
};

export default fileShareApiClient;
